<template>
  <div v-if="permissionReceptionDeskPackageComputed" class="popup-window-center">
    <div class="popup-body">
      <div class="card card-small entries-card">

        <div class="card-header entries-header d-flex justify-content-between">
          <div class="entries-heading">
            <span class="entries-heading-icon material-icons" aria-hidden="true">login</span>
            <div class="area-title">{{ $t('general.entries.entries') }}</div>
          </div>
          <div class="button-container-relative">

            <d-button class="btn-with-icon entries-checkin" @click="showCheckinPopupFunc">
              <span class="material-icons" aria-hidden="true">how_to_reg</span>
              {{ $t('general.entries.checkin') }}
            </d-button>

            <div class="popup-window-center" v-if="showCheckinPopup">
              <div class="check-in-component-place" >
                <CheckIn :all-gates="allGates"
                         v-on:close-check-in-form="closeCheckinPopupFunc"
                         @add-entrie="addEntrie"
                         :previously-selected-member-object="recordMemberObj"
                ></CheckIn>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body entries-body">

          <div class="content-container-overflow">
            <table class="table table-striped-custom table-hover-custom mb-0">
              <thead class="bg-light">
              <tr>
                <th scope="col" class="border-0" width="40%">{{ $t('general.entries.member') }}</th>
                <th scope="col" class="border-0" width="30%">{{ $t('general.entries.gate') }}</th>
                <th scope="col" class="border-0" width="30%">{{ $t('general.entries.time') }}</th>
                <th scope="col" class="border-0 menu-cell"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="entrie in entriesLst" :key="entrie.id">
                <td>{{ entrie.fullName }}</td>
                <td>{{ entrie.gateName }}</td>
                <td>{{ $i18n.locale === 'ar' ? formatReceptionArabicTimestamp(entrie.entryTimestamp) : $smartDate(entrie.entryTimestamp) }}</td>
                <td class="menu-cell">
                  <button type="button" class="entry-delete-action" :aria-label="$t('generalMessages.delete')" @click="removeEntrieRecord(entrie.id)">
                    <span class="material-icons">delete</span>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
                <PaginationBar
      :totalPages="totalPages"
      :totalCount="totalCount"
      :perPage.sync="perPage"
      :currentPage="currentPage"
      @pagechanged="onPageChange"
    />
          </div>
          <div class="entries-footer">
            <button type="button" class="btn btn-light entries-close" @click="close">{{ $t('general.entries.close') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CheckIn from '@/components/ReceptionDesk/CheckIn';
import PaginationBar from '@/components/Pagination/PaginationBar.vue';
import membersLogsService from '@/services/membersLogs.service';
import gatesService from '@/services/gates.service';
import { formatReceptionArabicTimestamp } from '@/utils/receptionArabicDateTime';

export default {
  name: 'EntriesPopup',
  components: { CheckIn, PaginationBar },
  props: {
    recordMemberObj: {
      type: Object,
    },
    recordId: {
      required: true,
      type: [Number, String],
    },
  },
  data() {
    return {
      entriesLst: [],
      showCheckinPopup: false,

      allGates: [],
      dateFromFilter: this.$date().subtract(30, 'day').utc().format('YYYY-MM-DDT00:00:00.000[Z]'),
      totalCount: 0,
      perPage: this.$store.state.settings.defaultPageSize,
      currentPage: 1,
      totalPages: 0,
      gateSelect: {
        selected: '',
        options: [
          {
            value: '',
            text: this.$t('gates.gates'),
          },
        ],
      },
    };
  },
  created() {
    this.setFilter();
    this.getEntries();
    this.getGates();
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.getEntries();
    },
    setFilter() {
      if (this.$session.get('receptionDeskDateFromFilter')) {
        this.dateFromFilter = this.$session.get('receptionDeskDateFromFilter');
      }
    },
    async getEntries() {
      this.$store.commit('changeShowLoader', true);
      // const fullname = `${this.recordMemberObj.givenName} ${this.recordMemberObj.middleName} ${this.recordMemberObj.familyName}`;
      await membersLogsService.list({
        MemberId: this.recordMemberObj.id,
        DateFrom: this.dateFromFilter,
        take: this.perPage,
        skip: (this.currentPage - 1) * this.perPage,
      })
        .then((data) => {
          if (data && data.status === true) {
            this.entriesLst = data.data;
            this.totalCount = data.totalCount;
            this.totalPages = Math.ceil(this.totalCount / this.perPage);
          } else {
            throw 'Server return status false';
          }
        })
        .catch((err) => {
          this.showError(err, this.$t('errors.entities.entries'), 'load');
        });
      this.$store.commit('changeShowLoader', false);
    },
    async getGates() {
      this.$store.commit('changeShowLoader', true);
      await gatesService.list({ perPage: 99999 })
        .then((data) => {
          this.allGates = data.data;
          this.gateSelect.options = [
            ...this.gateSelect.options,
            ...data.data.map((g) => ({
              value: g.id,
              text: g.name,
            })),
          ];
        })
        .catch((err) => {
          this.showError(err, this.$t('errors.entities.entries'), 'load');
        });
      this.$store.commit('changeShowLoader', false);
    },
    async removeEntrieRecord(recordId) {
      this.$confirm(this.$t('general.entries.deleteConfirmation'), undefined, undefined, { confirmButtonText: this.$t('generalMessages.Ok'), cancelButtonText: this.$t('generalMessages.cancel') }).then(async () => {
        this.$store.commit('changeShowLoader', true);
        await membersLogsService.bulkDelete([recordId])
          .then((data) => {
            if (data) {
              this.$toast.success(this.$t('general.entries.entryDeletedSuccessfully'));
              this.getEntries();
            } else {
              throw 'Server return status false';
            }
          })
          .catch((err) => {
            this.showError(err, this.$t('errors.entities.entry'), 'delete');
          });
        this.$store.commit('changeShowLoader', false);
      });
    },
    close() {
      this.$emit('close');
    },
    showCheckinPopupFunc() {
      setTimeout(() => {
        this.showCheckinPopup = true;
      }, 50);
    },
    addEntrie() {
      // Reload from the server instead of optimistically pushing: the emitted
      // entry stamps local wall-clock time with a literal Z, which renders
      // +offset under $smartDate, and it carries no id (breaking row delete).
      this.showCheckinPopup = false;
      this.currentPage = 1;
      this.getEntries();
    },
    formatReceptionArabicTimestamp,
    closeCheckinPopupFunc(reload = false) {
      this.showCheckinPopup = false;
      if (reload) {
        this.getEntries();
      }
    },
  },
  computed: {
    permissionReceptionDeskPackageComputed() {
      return this.hasFeature('check-ins');
    },
  },
  watch: {
    perPage() {
      this.currentPage = 1;
      this.getEntries();
    },
  },
};
</script>

<style scoped>
.entries-card { border: 1px solid #e3ebf1; border-radius: 14px; box-shadow: 0 18px 50px rgba(31, 57, 80, .16); margin: 0 auto; max-height: min(88vh, 44rem); overflow: hidden; padding: 0; width: min(calc(100vw - 2rem), 60rem); }
.entries-header { align-items: center; border-bottom: 1px solid #e8eef3; padding: 1rem 1.15rem; }
.entries-heading { align-items: center; display: flex; gap: .65rem; }
.entries-heading .area-title { color: #254766; font-size: 1.1rem; margin: 0; }
.entries-heading-icon { align-items: center; background: rgba(0, 152, 184, .1); border-radius: 9px; color: var(--fitnet-primary); display: inline-flex; font-size: 1.2rem; height: 2.35rem; justify-content: center; width: 2.35rem; }
.entries-checkin { gap: .35rem; }
.entries-checkin .material-icons { font-size: 1.05rem; }
.entries-body { padding: 1rem 1.15rem !important; }
.content-container-overflow {
  border: 1px solid #e5ecf1;
  border-radius: 9px;
  max-height: 430px;
  overflow-y: auto;
}
.entry-delete-action { align-items: center; background: transparent; border: 0; border-radius: 6px; color: #8797a7; cursor: pointer; display: inline-flex; height: 2rem; justify-content: center; padding: 0; width: 2rem; }
.entry-delete-action .material-icons { font-size: 1.1rem; }
.entry-delete-action:hover,
.entry-delete-action:focus { background: #fff0f0; color: #d14343; }
.entries-footer { align-items: center; display: flex; justify-content: flex-end; padding-top: .9rem; }
.entries-close { border-color: #dce4ea; color: #61768a; }

.button-container-relative {
  position: relative;
}

.check-in-component-place {
  z-index: 1080;
  position: fixed;
  /* background-color: white; */
  width: 100vw;
  max-width: 500px;
  /* top: calc(100% + 5px); */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
